import * as noshow from "./noshow/variables.scss.js";
import * as yservices from "./yservices/variables.scss.js";

const assignStyle = (instance) => {
    const style = THEME === "yservices" ? yservices.default : noshow.default;

    if (instance?.config?.globalProperties) {
        instance.config.globalProperties.$style = style;
    }

    if (instance?.prototype) {
        instance.prototype.$style = style;
    }
};

export default {
    install(instance) {
        assignStyle(instance);
    },
};
